// @docs https://[domain]/api/v1/docs
export default {
  List: "/branches",
  Detail: "/branches",
  Update: "/branches",
  Create: "/branches",
  ListShort: "/branches/short",
};
